import { 
  statusPartnerStart,
  statusPartnerSuccess,
  statusPartnerFailure 
} from "./partnerSlice";
import { getCustom, post, put, remove } from "../../requestMethods"

export const ShowPartnerApi = () => async (dispatch: any) => {
  try {
    dispatch(statusPartnerStart())
    const res = await getCustom("partner");
    const resData = res.data.success
    if(resData) {
      dispatch(statusPartnerSuccess(resData))
      return true
    }
  } catch (err: any) {
    const errData = err.response.data
    const formErrors = errData.formErrors ? errData.formErrors : [errData];
    if(err.response && err.response.status === 300) {
      dispatch(statusPartnerFailure(formErrors))
      return formErrors
    } else {
      dispatch(statusPartnerFailure(errData.err))
      return [errData.err]  
    }
  }
}

export const AddPartnerApi = (partner: any) => async (dispatch: any) => {
  try {
    dispatch(statusPartnerStart())
    const response = await post("partner", partner)
    const resData  = await response.data.success
    if(resData) {
      dispatch(statusPartnerSuccess(resData))
      return true;
    }
  } catch (err: any) {
    const errData = err.response.data
    const formErrors = errData.formErrors ? errData.formErrors : [errData];
    if(err.response && err.response.status === 300) {
      dispatch(statusPartnerFailure(formErrors))      
      return formErrors
    } else {
      dispatch(statusPartnerFailure(errData.err))      
      return [errData.err]
    }
  }
}

export const EditPartnerApi = (id: any, partner: any) => async (dispatch: any) => {
  try {
    dispatch(statusPartnerStart())
    const response = await put(`partner/${id}`, partner);
    const resData = response.data.success
    if(resData) {
      dispatch(statusPartnerSuccess(resData))
      return true;
    }
  }catch (err: any) {
    const errData = err.response.data
    const formErrors = errData.formErrors ? errData.formErrors : [errData];
    if(err.response && err.response.status === 300) {
      dispatch(statusPartnerFailure(formErrors))
      return formErrors
    } else {
      dispatch(statusPartnerFailure(errData.err))
      return [errData.err]
    }
  }
}

export const DeletePartnerApi = (id: string) => async (dispatch: any) => {
  try {
    dispatch(statusPartnerStart());
    const response = await remove(`partner/${id}`);
    const resData = response.data.success
    if(resData) {
      dispatch(statusPartnerSuccess(resData))
      return true;
    }
  } catch(err: any) {
    const errData = err.response.data
    const formErrors = errData.formErrors ? errData.formErrors : [errData];
    if(err.response && err.response.status === 300) {
      dispatch(statusPartnerFailure(formErrors))
      return formErrors
    } else {
      dispatch(statusPartnerFailure(errData.err))
      return errData.err
    }
  }
}

export const AddPartnerSupportApi = (assId: any, support: any) => async (dispatch: any) => {
  try {
    dispatch(statusPartnerStart())
    const response = await post(`partner/${assId}/support`, support);
    const resData = response.data.success
    if(resData) {
      dispatch(statusPartnerSuccess(resData))
      return true;
    }
  } catch(err: any) {
    const errData = err.response.data
    const formErrors = errData.formErrors ? errData.formErrors : [errData];
    if(err.response && err.response.status === 300) {
      dispatch(statusPartnerFailure(formErrors));
      return formErrors
    } else {
      dispatch(statusPartnerFailure(errData.err));
      return [errData.err]
    }
  }
}

export const EditPartnerSupportApi = (assId: string = "", support: any, supportId: string) => async (dispatch: any) => {
  try {
    dispatch(statusPartnerStart())
    const response = await put(`partner/${assId}/support/${supportId}`, support);
    const resData = response.data.success
    if(resData) {
      dispatch(statusPartnerSuccess(resData));
      return true
    }
  } catch (err: any) {
    const errData = err.response.data
    const formErrors = errData.formErrors ? errData.formErrors : [errData];
    if(err.response && err.response.status === 300) {
      dispatch(statusPartnerFailure(formErrors))
      return formErrors
    } else {
      dispatch(statusPartnerFailure(errData.err))
      return [errData.err]
    }
  }
}

export const DeletePartnerSupportApi = (assId: any, supportId: any) => async (dispatch: any) => {
  try {
    dispatch(statusPartnerStart())
    const response = await remove(`partner/${assId}/support/${supportId}`);
    const resData = response.data.success
    if(resData) {
      dispatch(statusPartnerSuccess(resData));
      return true
    }
  } catch (err: any) {
    const errData = err.response.data
    const formErrors = errData.formErrors ? errData.formErrors : [errData];
    if(err.response && err.response.status === 300) {
      dispatch(statusPartnerFailure(formErrors))
      return formErrors
    } else {
      dispatch(statusPartnerFailure(errData.err))
      return [errData.err]
    }
  }
} 


export const clearPartnersApi = (dispatch: any) => {
  dispatch(statusPartnerSuccess([]))
}